<!--单条明细-->
<template>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog" @close="afterCloseDialog"
  >

    <div ref="print1" style="width: 640px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">
        {{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder">
          <td align="right">货品名：</td>
          <td colspan="3">{{seedname}}</td>
          <td align="right">编&nbsp;&nbsp;&nbsp;&nbsp;码：</td>
          <td>{{seedcode}}</td>
        </tr>

        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">出&nbsp;&nbsp;库：</td>
          <td>{{controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">门&nbsp;&nbsp;店：</td>
          <td width="140">{{controlData.customername}}</td>
          <td align="right" width="60">地&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.deliveryaddress}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="120">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>
        </tr>
        <tr v-show="showerweitable">
          <td colspan="6" style="border:none">
            <TwoDimensionalTable ref="referweibiao" :readonly="true" :needSetHeight="false" :needSetDisabled="false"
                                 :isshowprice="isshowprice" :price="price"
            ></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :readonly="true" :needSetHeight="false"
                                   :needSetDisabled="false"
              ></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :readonly="true" :needSetHeight="false"
                                   :needSetDisabled="false"
              ></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" style="padding-top: 5px;">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px;padding-top: 5px;">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder" style="height:46px">
          <td colspan="4">&nbsp;&nbsp;&nbsp;开单人员：{{controlData.ssfzr||""}}</td>
          <td colspan="2">出库人员：{{controlData.handleoveruname||""}}</td>
        </tr>
        <tr class="noborder" style="height:15px">
          <td colspan="4">&nbsp;</td>
          <td colspan="2"></td>
        </tr>
        <tr class="noborder">
          <td align="right">GZ.NO：</td>
          <td width="135">{{controlData.logisticstracknum||""}}</td>
          <td align="right">GY.NO：</td>
          <td colspan="3">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="controlData.tracknum&&controlData.tracknum.length>=14&&controlData.tracknum.substr(0,2)=='42'">{{controlData.tracknum||""}}</a>
            <a v-else>{{controlData.tracknum||""}}</a>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">服务商：</td>
          <td>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false;afterCloseDialog()">取 消</el-button>
      <el-button type="primary" @click="print1">打印</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
    </div>
    <printlogList ref="printlogList"></printlogList>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename"></Printtitle>
    <BuyfromList ref="BuyfromList"></BuyfromList>
  </el-dialog>
</template>


<script>
  import {getPrice} from '@/api/set/goodsprice';
  import {printing, checkprinting} from '@/api/set/csagreement';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getRemark, getKHRemark} from '@/plugin/ordercommon';
  import {save} from '@/api/order/printlog';
  import printlogList from './printlogList'
  import Printtitle from './Printtitle'
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'

  export default {
    inject: ["afterCloseDialog"],
    name: 'CstagreementEditSeedDetail',
    data() {
      return {
        formLabelWidth: '120px',
        isprint: false,
        dialogSeeVisible: false,
        loading: true,
        pagetitle: '',
        seedcode: "",
        seedname: '',
        tableData: [],
        column: [],
        controlData: {},
        erweitable: [],
        costpricebook: {},
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        showtitle1: 'none',
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        totalnumber: 0,
        printDisplay: false,//打印是否显示价格
        isshowprice: true,
        price: {},//商品单价和总价
        uname: '',//打印人
        adddate: '',//打印时间
      }
    },
    methods: {
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum,this.controlData.pcustomerserial);
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            obj[i] += "销售订单"
          }
          result = obj.join(';')
        } else {
          result += "销售订单"
        }
        return result
      },
      showDetail(item) {

      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      //打印日志
      print1() {
        // window.print()
        this.showtitle1 = ""
        checkprinting({erpserial: this.controlData.erpserial}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1)
                this.$refs.Printtitle.show(this.pagetitle, false)
              else
                this.startprint(false);
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1)
              this.$refs.Printtitle.show(this.pagetitle, true)
            else
              this.startprint(true);
          }
        });
      },
      printtitlename(pagetitle, needreflash) {
        this.pagetitle = pagetitle
        this.startprint(needreflash)
      },
      startprint(needreflash) {
        if (!this.printDisplay) {
          this.isshowprice = false
        }
        this.isprint = true
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.isshowprice = true
          this.isprint = false
          save({erpserial: this.controlData.erpserial, invoicesource: 3}).then(response => {
            if (response.data.code == 0) {
              if (needreflash) {
                this.dialogSeeVisible = false
                this.$emit("shuxiprint");//未打印过，刷新父页面
              }
              this.$message({
                message: '生成打印日志',
                type: 'success'
              })
            }
          })
        })
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.controlData.erpserial);
      },
      show(price) {
        this.dialogSeeVisible = true;
        if (price)
          this.price = price
      },
      getLiuYan(remark) {
        if (this.isprint) {
          return getKHRemark(remark);
        }
        return getRemark(remark);
      },
      initData(unitguid, seedcode, erpserial, filltemplate) {
        this.initForm()
        this.filltemplate = filltemplate
        this.seedcode = seedcode
        printing({
          unitguid: unitguid,
          erpserial: erpserial,
          seedcode: this.seedcode,
          filltemplate: this.filltemplate
        }).then(response => {

          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          //打印日志
          if (response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          this.controlData = response.data.obj.detail;
          this.printDisplay = (this.controlData.isshowprice.indexOf('4') != -1);

          if (this.controlData) {
            this.price['单价'] = this.controlData['pricetax']
            this.price['总价'] = this.controlData['htje']
          }
          this.BookContent = response.data.obj.goodsDetail
          this.seedname = response.data.obj.seedname
          this.BookContent.forEach(o => {
            this.totalnumber = this.totalnumber + o.P
          })
          if (!filltemplate)
            this.filltemplate = response.data.obj.filltemplate
          if (this.filltemplate == "30") {
            this.showzuoyoutable = true
            this.BookContent.forEach(o => {
              if (o.type == "L")
                this.BookContentLeft.push(o)
              else
                this.BookContentRight.push(o)
            })
            this.$refs.referweibiaoleft.initBookFix(this.BookContentLeft)
            this.$refs.referweibiaoright.initBookFix(this.BookContentRight)
          } else {
            this.showerweitable = true
            this.$refs.referweibiao.initBookFix(this.BookContent)
          }
          //判断是否有成本价
          //this.getXYRange()
        });

      },
      //
      // getXYRange() {
      //   getPrice({seedcode: this.seedcode}).then((response) => {
      //     if (response.data.code == 0 && response.data.obj) {
      //       this.costpricebook = response.data.obj
      //     } else {
      //       this.costpricebook = {}
      //     }
      //     this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
      //   })
      //
      // },

      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        this.BookContentLeft = []
        this.BookContentRight = []
        this.BookContent = []
        this.filltemplate = ""
        this.column = []
        this.tableData = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.totalnumber = 0
        this.printDisplay = false
        this.isshowprice = true//单价总价显示
      }

    },
    mounted() {

    },
    components: {
      TwoDimensionalTable,
      printlogList,
      Printtitle,
      BuyfromList
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEditSeedDetail.vue